var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[(_vm.label)?_c('p',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('v-slider',{attrs:{"name":_vm.name,"min":20,"max":_vm.max,"value":_vm.rangeValue || 20},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }